export const supportedChains = [
  {
    name: 'Unsupported network!',
    short_name: 'loc',
    chain: 'ETH',
    network: 'local',
    chain_id: 31337, // unit16, uint32 ?
    network_id: -1, // true ?
    rpc_url: 'http://',
    explorer_scan: '',
    api_url: '',
    native_currency: {
      symbol: 'ETH',
      name: 'Ethereum',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  },
  // {
  //   name: 'Ethereum Mainnet',
  //   short_name: 'ETH', // 
  //   chain: 'ETH',
  //   network: 'ETH',
  //   chain_id: 1,
  //   network_id: 1,
  //   rpc_url: 'https://uk.rpc.blxrbdn.com',
  //   block_scan: '',
  //   api_url: '',
  //   native_currency: {
  //     symbol: 'ETH',
  //     name: 'ETH',
  //     decimals: '18',
  //     contractAddress: '',
  //     balance: ''
  //   }
  // },

  // {
  //   name: 'Goerli',
  //   short_name: 'goe', // rop - Goerli
  //   chain: 'ETH',
  //   network: 'goerli',
  //   chain_id: 5,
  //   network_id: 5, // save RPC +1 = 2
  //   rpc_url: 'https://ethereum-goerli.publicnode.com' || 'https://eth-goerli.public.blastapi.io', // save RPC +1 = 2
  //   explorer_scan: 'https://goerli.etherscan.io/',
  //   api_url: '',
  //   native_currency: {
  //     symbol: 'ETH',
  //     name: 'ETH',
  //     decimals: '18',
  //     contractAddress: '',
  //     balance: ''
  //   }
  // },
  {
    name: 'Sepolia',
    short_name: 'Sepolia',
    chain: 'Sepolia',
    network: 'Sepolia',
    chain_id: 11155111,
    network_id: 11155111,
    rpc_url: 'https://ethereum-sepolia.publicnode.com' || 'https://eth-sepolia.public.blastapi.io',
    explorer_scan: 'https://sepolia.etherscan.io/',
    api_url: '',
    native_currency: {
      symbol: 'ETH',
      name: 'ETH',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  },
  {
    name: 'Holesky',
    short_name: 'hol', // rop - Goerli
    chain: 'ETH',
    network: 'holesky',
    chain_id: 17000,
    network_id: 17000,
    rpc_url: 'https://ethereum-holesky.publicnode.com' || 'https://holesky.rpc.thirdweb.com',
    explorer_scan: 'https://holesky.etherscan.io/',
    api_url: '',
    native_currency: {
      symbol: 'ETH',
      name: 'ETH',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  },
  // {
  //   name: 'Mumbai - Testnet',
  //   short_name: 'MATIC',
  //   chain: 'MATIC',
  //   network: 'MATIC',
  //   chain_id: 80001,
  //   network_id: 80001,
  //   rpc_url: 'https://polygon-mumbai-bor.publicnode.com' || 'https://polygon-testnet.public.blastapi.io',
  //   explorer_scan: 'https://mumbai.polygonscan.com/',
  //   api_url: '',
  //   native_currency: {
  //     symbol: 'MATIC',
  //     name: 'MATIC',
  //     decimals: '18',
  //     contractAddress: '',
  //     balance: ''
  //   }
  // },
  {
    name: 'Amoy - Testnet',
    short_name: 'MATIC',
    chain: 'MATIC',
    network: 'MATIC',
    chain_id: 80002,
    network_id: 80002,
    rpc_url: 'https://rpc-amoy.polygon.technology',
    explorer_scan: 'https://www.oklink.com/amoy/',
    api_url: '',
    native_currency: {
      symbol: 'MATIC',
      name: 'MATIC',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  },
  {
    name: 'BNB Smart Chain - Testnet',
    short_name: 'tbnb',
    chain: 'smartchain',
    network: 'smartchain',
    chain_id: 97,
    network_id: 97,
    rpc_url: 'https://data-seed-prebsc-1-s1.bnbchain.org:8545' || 'https://bsc-testnet.public.blastapi.io',
    explorer_scan: 'https://testnet.bscscan.com/',
    api_url: '',
    native_currency: {
      symbol: 'BNB',
      name: 'BNB',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  },
  // {
  //   name: 'Arbitrum Goerli - Testnet',
  //   short_name: 'ETH',
  //   chain: 'ETH',
  //   network: 'ETH',
  //   chain_id: 421613,
  //   network_id: 421613,
  //   rpc_url: 'https://goerli-rollup.arbitrum.io/rpc' || 'https://arbitrum-goerli.publicnode.com',
  //   explorer_scan: 'https://testnet.arbiscan.io/',
  //   api_url: '',
  //   native_currency: {
  //     symbol: 'ETH',
  //     name: 'ETH',
  //     decimals: '18',
  //     contractAddress: '',
  //     balance: ''
  //   }
  // },
  {
    name: 'Arbitrum Sepolia - Testnet',
    short_name: 'ETH',
    chain: 'ETH',
    network: 'ETH',
    chain_id: 421614,
    network_id: 421614,
    rpc_url: 'https://sepolia-rollup.arbitrum.io/rpc' || 'https://public.stackup.sh/api/v1/node/arbitrum-sepolia',
    explorer_scan: 'https://testnet.arbiscan.io/',
    api_url: '',
    native_currency: {
      symbol: 'ETH',
      name: 'ETH',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  },
  // {
  //   name: 'Optimism Goerli - Testnet',
  //   short_name: 'ETH',
  //   chain: 'ETH',
  //   network: 'ETH',
  //   chain_id: 420,
  //   network_id: 420,
  //   rpc_url: 'https://goerli.optimism.io' || 'https://optimism-goerli.public.blastapi.io',
  //   explorer_scan: 'https://goerli-optimism.etherscan.io/',
  //   api_url: '',
  //   native_currency: {
  //     symbol: 'ETH',
  //     name: 'ETH',
  //     decimals: '18',
  //     contractAddress: '',
  //     balance: ''
  //   }
  // },
  {
    name: 'Optimism Sepolia - Testnet',
    short_name: 'ETH',
    chain: 'ETH',
    network: 'ETH',
    chain_id: 11155420,
    network_id: 11155420,
    rpc_url: 'https://sepolia.optimism.io' || 'https://optimism-sepolia.blockpi.network/v1/rpc/public',
    explorer_scan: '',
    api_url: '',
    native_currency: {
      symbol: 'ETH',
      name: 'ETH',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  },
  // {
  //   name: 'Base Goerli - Testnet',
  //   short_name: 'ETH',
  //   chain: 'ETH',
  //   network: 'ETH',
  //   chain_id: 84531,
  //   network_id: 84531,
  //   rpc_url: 'https://goerli.base.org' || 'https://base-goerli.public.blastapi.io',
  //   explorer_scan: 'https://goerli.basescan.org/',
  //   api_url: '',
  //   native_currency: {
  //     symbol: 'ETH',
  //     name: 'ETH',
  //     decimals: '18',
  //     contractAddress: '',
  //     balance: ''
  //   }
  // }
  // ,
  {
    name: 'Base Sepolia - Testnet',
    short_name: 'ETH',
    chain: 'ETH',
    network: 'ETH',
    chain_id: 84532,
    network_id: 84532,
    rpc_url: 'https://sepolia.base.org' || 'https://base-sepolia-rpc.publicnode.com',
    explorer_scan: 'https://sepolia.basescan.org/',
    api_url: '',
    native_currency: {
      symbol: 'ETH',
      name: 'ETH',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'Linea - Testnet',
    short_name: 'tlin', //
    chain: 'ETH',
    network: 'testnet',
    chain_id: 59140,
    network_id: 59140,
    rpc_url: 'https://rpc.goerli.linea.build',
    explorer_scan: 'https://goerli.lineascan.build/',
    api_url: '',
    native_currency: {
      symbol: 'ETH',
      name: 'ETH',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'Avalanche Fuji - Testnet',
    short_name: 'tavax', //
    chain: 'AVAX',
    network: 'testnet',
    chain_id: 43113,
    network_id: 43113,
    rpc_url: 'https://avalanche-fuji-c-chain.publicnode.com' || 'https://ava-testnet.public.blastapi.io/ext/bc/C/rpc',
    explorer_scan: 'https://testnet.snowtrace.io/',
    api_url: '',
    native_currency: {
      symbol: 'AVAX',
      name: 'AVAX',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'Fantom - Testnet',
    short_name: 'tftm', // 
    chain: 'FTM',
    network: 'FTM',
    chain_id: 4002,
    network_id: 4002,
    rpc_url: 'https://rpc.testnet.fantom.network' || 'https://fantom.api.onfinality.io/public',
    explorer_scan: 'https://testnet.ftmscan.com/',
    api_url: '',
    native_currency: {
      symbol: 'FTM',
      name: 'FTM',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'Bitkub Chain - Testnet',
    short_name: 'tkub', // 
    chain: 'KUB',
    network: 'KUB',
    chain_id: 25925,
    network_id: 25925,
    rpc_url: 'https://rpc-testnet.bitkubchain.io' || 'wss://wss-testnet.bitkubchain.io',
    explorer_scan: 'https://testnet.bkcscan.com/',
    api_url: '',
    native_currency: {
      symbol: 'tKUB',
      name: 'tKUB',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  },
  {
    name: 'Flare - Testnet Coston',
    short_name: 'CFLR', // 
    chain: 'CFLR',
    network: 'CFLR',
    chain_id: 16,
    network_id: 16,
    rpc_url: 'https://coston-api.flare.network/ext/bc/C/rpc',
    explorer_scan: 'https://coston-explorer.flare.network/',
    api_url: '',
    native_currency: {
      symbol: 'CFLR',
      name: 'CFLR',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'Public Goods Network - Testnet',
    short_name: '', // 
    chain: '',
    network: '',
    chain_id: 58008,
    network_id: 58008,
    rpc_url: 'https://sepolia.publicgoods.network',
    explorer_scan: 'https://explorer.sepolia.publicgoods.network/',
    api_url: '',
    native_currency: {
      symbol: 'ETH',
      name: 'ETH',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'Haqq Chain - Testnet',
    short_name: '', // 
    chain: '',
    network: '',
    chain_id: 54211,
    network_id: 54211,
    rpc_url: 'https://rpc.eth.testedge2.haqq.network',
    explorer_scan: 'https://explorer.testedge2.haqq.network/',
    api_url: '',
    native_currency: {
      symbol: 'ISLMT',
      name: 'ISLMT',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'Lightlink - Testnet Pegasus',
    short_name: '', // 
    chain: '',
    network: '',
    chain_id: 1891,
    network_id: 1891,
    rpc_url: 'https://replicator-01.pegasus.lightlink.io/rpc/v1',
    explorer_scan: 'https://pegasus.lightlink.io/',
    api_url: '',
    native_currency: {
      symbol: 'ETH',
      name: 'ETH',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'Taiko - Testnet Jolnir L2',
    short_name: '', // 
    chain: '',
    network: '',
    chain_id: 167007,
    network_id: 167007,
    rpc_url: 'https://rpc.jolnir.taiko.xyz',
    explorer_scan: 'https://explorer.jolnir.taiko.xyz/',
    api_url: '',
    native_currency: {
      symbol: 'ETH',
      name: 'ETH',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'Mode - Testnet',
    short_name: '', // 
    chain: '',
    network: '',
    chain_id: 919,
    network_id: 919,
    rpc_url: 'https://sepolia.mode.network',
    explorer_scan: 'https://sepolia.explorer.mode.network/',
    api_url: '',
    native_currency: {
      symbol: 'ETH',
      name: 'ETH',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  //
  {
    name: 'Neo EVM - Testnet',
    short_name: '', // 
    chain: '',
    network: '',
    chain_id: 2970385,
    network_id: 2970385,
    rpc_url: 'https://evm.ngd.network:32331',
    explorer_scan: 'https://evm.ngd.network/',
    api_url: '',
    native_currency: {
      symbol: 'GAS',
      name: 'GAS',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'ZetaChain - Testnet Athens 3',
    short_name: '', // 
    chain: '',
    network: '',
    chain_id: 7001,
    network_id: 7001,
    rpc_url: 'https://zetachain-athens-evm.blockpi.network/v1/rpc/public' || 'https://rpc.ankr.com/zetachain_evm_athens_testnet',
    explorer_scan: 'https://zetachain-athens-3.blockscout.com/',
    api_url: '',
    native_currency: {
      symbol: 'aZETA',
      name: 'aZETA',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'Scroll - Testnet Sepolia',
    short_name: '', // 
    chain: '',
    network: '',
    chain_id: 534351,
    network_id: 534351,
    rpc_url: 'https://sepolia-rpc.scroll.io' || 'https://1rpc.io/scroll/sepolia',
    explorer_scan: 'https://sepolia.scrollscan.dev/',
    api_url: '',
    native_currency: {
      symbol: 'ETH',
      name: 'ETH',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'Mantle - Testnet',
    short_name: '', // 
    chain: '',
    network: '',
    chain_id: 5001,
    network_id: 5001,
    rpc_url: 'https://rpc.testnet.mantle.xyz',
    explorer_scan: 'https://explorer.testnet.mantle.xyz/',
    api_url: '',
    native_currency: {
      symbol: 'MNT',
      name: 'MNT',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'opBNB - Testnet',
    short_name: '', // 
    chain: '',
    network: '',
    chain_id: 5611,
    network_id: 5611,
    rpc_url: 'https://opbnb-testnet-rpc.bnbchain.org',
    explorer_scan: 'https://testnet.opbnbscan.com/',
    api_url: '',
    native_currency: {
      symbol: 'tBNB',
      name: 'tBNB',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'Omni Network - Testnet',
    short_name: '', // 
    chain: '',
    network: '',
    chain_id: 165,
    network_id: 165,
    rpc_url: 'https://testnet.omni.network',
    explorer_scan: 'https://testnet.explorer.omni.network/',
    api_url: '',
    native_currency: {
      symbol: 'OMNI',
      name: 'OMNI',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'Manta Pacific - Testnet',
    short_name: '', // 
    chain: '',
    network: '',
    chain_id: 3441005,
    network_id: 3441005,
    rpc_url: 'https://manta-testnet.calderachain.xyz/http',
    explorer_scan: 'https://manta-testnet.calderaexplorer.xyz/',
    api_url: '',
    native_currency: {
      symbol: 'MANTA',
      name: 'MANTA',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'Kroma - Testnet Sepolia',
    short_name: '', // 
    chain: '',
    network: '',
    chain_id: 2358,
    network_id: 2358,
    rpc_url: 'https://api.sepolia.kroma.network',
    explorer_scan: 'https://blockscout.sepolia.kroma.network/',
    api_url: '',
    native_currency: {
      symbol: 'ETH',
      name: 'ETH',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'Polygon zkEVM - Testnet',
    short_name: '', // 
    chain: '',
    network: '',
    chain_id: 1442,
    network_id: 1442,
    rpc_url: 'https://rpc.public.zkevm-test.net',
    explorer_scan: 'https://testnet-zkevm.polygonscan.com/',
    api_url: '',
    native_currency: {
      symbol: 'ETH',
      name: 'ETH',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'Shardeum Sphinx 1.X - Testnet Dapp',
    short_name: '', // 
    chain: '',
    network: '',
    chain_id: 8081,
    network_id: 8081,
    rpc_url: 'https://dapps.shardeum.org',
    explorer_scan: 'https://explorer-dapps.shardeum.org',
    api_url: '',
    native_currency: {
      symbol: 'SHM',
      name: 'SHM',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'X1 (OKX L2) - Testnet',
    short_name: '', // 
    chain: '',
    network: '',
    chain_id: 195,
    network_id: 195,
    rpc_url: 'https://x1testrpc.okx.com',
    explorer_scan: 'https://www.oklink.com/x1-test',
    api_url: '',
    native_currency: {
      symbol: 'OKB',
      name: 'OKB',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'Arbitrum Stylus - Testnet',
    short_name: '', // 
    chain: '',
    network: '',
    chain_id: 23011913,
    network_id: 23011913,
    rpc_url: 'https://stylus-testnet.arbitrum.io/rpc',
    explorer_scan: 'https://stylus-testnet-explorer.arbitrum.io/',
    api_url: '',
    native_currency: {
      symbol: 'ETH',
      name: 'ETH',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'Frame - Testnet',
    short_name: '', // 
    chain: '',
    network: '',
    chain_id: 68840142,
    network_id: 68840142,
    rpc_url: 'https://rpc.testnet.frame.xyz/http',
    explorer_scan: 'https://explorer.testnet.frame.xyz/',
    api_url: '',
    native_currency: {
      symbol: 'ETH',
      name: 'ETH',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'zKatana - Testnet',
    short_name: '', // 
    chain: '',
    network: '',
    chain_id: 1261120,
    network_id: 1261120,
    rpc_url: 'https://rpc.startale.com/zkatana',
    explorer_scan: 'https://zkatana.blockscout.com/',
    api_url: '',
    native_currency: {
      symbol: 'ETH',
      name: 'ETH',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'Redstone - Testnet',
    short_name: '', // 
    chain: '',
    network: '',
    chain_id: 17001,
    network_id: 17001,
    rpc_url: 'https://rpc.holesky.redstone.xyz',
    explorer_scan: 'https://goerli.explorer.zksync.io/',
    api_url: '',
    native_currency: {
      symbol: 'ETH',
      name: 'ETH',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'Gnosis - Testnet Chiado',
    short_name: '', // 
    chain: '',
    network: '',
    chain_id: 10200,
    network_id: 10200,
    rpc_url: 'https://rpc.chiadochain.net',
    block_scan: '',
    api_url: '',
    native_currency: {
      symbol: 'XDAI',
      name: 'XDAI',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'Zora Sepolia - Testnet',
    short_name: '', // 
    chain: '',
    network: '',
    chain_id: 999999999,
    network_id: 999999999,
    rpc_url: 'https://sepolia.rpc.zora.energy',
    block_scan: 'https://sepolia.explorer.zora.energy',
    api_url: '',
    native_currency: {
      symbol: 'ETH',
      name: 'ETH',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'Blast Sepolia',
    short_name: '', // 
    chain: '',
    network: '',
    chain_id: 168587773,
    network_id: 168587773,
    rpc_url: 'https://sepolia.blast.io',
    block_scan: 'https://testnet.blastscan.io',
    api_url: '',
    native_currency: {
      symbol: 'ETH',
      name: 'ETH',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'Taiko Katla',
    short_name: '', // 
    chain: '',
    network: '',
    chain_id: 167008,
    network_id: 167008,
    rpc_url: 'https://rpc.katla.taiko.xyz',
    block_scan: 'https://explorer.katla.taiko.xyz',
    api_url: '',
    native_currency: {
      symbol: 'ETH',
      name: 'ETH',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'Berachain Artio',
    short_name: '', 
    chain: '',
    network: '',
    chain_id: 80085,
    network_id: 80085,
    rpc_url: 'https://artio.rpc.berachain.com',
    block_scan: 'https://testnet.beratrail.io',
    api_url: '',
    native_currency: {
      symbol: 'BERA',
      name: 'BERA',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'Tabichain 1.0 - Testnet',
    short_name: '', 
    chain: '',
    network: '',
    chain_id: 9789,
    network_id: 9789,
    // rpc_url: 'https://rpc.testnet.tabichain.com',
    rpc_url: 'https://rpc.testnet.tabichain.com',
    block_scan: 'https://testnet.tabiscan.com',
    api_url: '',
    native_currency: {
      symbol: 'TABI',
      name: 'TABI',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'Taiko - Testnet Hekla L2',
    short_name: '', 
    chain: '',
    network: '',
    chain_id: 167009,
    network_id: 167009,
    rpc_url: 'https://rpc.hekla.taiko.xyz',
    block_scan: 'https://hekla.taikoscan.network',
    api_url: '',
    native_currency: {
      symbol: 'ETH',
      name: 'ETH',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'ALIENX Hal - Testnet',
    short_name: '', 
    chain: '',
    network: '',
    chain_id: 10241025,
    network_id: 10241025,
    rpc_url: 'https://hal-rpc.alienxchain.io/http',
    block_scan: 'https://hal-explorer.alienxchain.io',
    api_url: '',
    native_currency: {
      symbol: 'ETH',
      name: 'ETH',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'Sei - Testnet',
    short_name: '', 
    chain: '',
    network: '',
    chain_id: 1328,
    network_id: 1328,
    rpc_url: 'https://evm-rpc-testnet.sei-apis.com',
    block_scan: 'https://seitrace.com',
    api_url: '',
    native_currency: {
      symbol: 'SEI',
      name: 'SEI',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'Soneium - Minato',
    short_name: '', 
    chain: '',
    network: '',
    chain_id: 1946,
    network_id: 1946 ,
    rpc_url: 'https://rpc.minato.soneium.org',
    block_scan: 'https://explorer-testnet.soneium.org',
    api_url: '',
    native_currency: {
      symbol: 'ETH',
      name: 'ETH',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'Story - Testnet',
    short_name: '', 
    chain: '',
    network: '',
    chain_id: 1513,
    network_id: 1513 ,
    rpc_url: 'https://testnet.storyrpc.io',
    block_scan: 'https://testnet.storyscan.xyz',
    api_url: '',
    native_currency: {
      symbol: 'IP',
      name: 'IP',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'Hemi - Sepolia',
    short_name: '', 
    chain: '',
    network: '',
    chain_id: 743111,
    network_id: 743111 ,
    rpc_url: 'https://testnet.rpc.hemi.network/rpc',
    block_scan: 'https://testnet.explorer.hemi.xyz',
    api_url: '',
    native_currency: {
      symbol: 'ETH',
      name: 'ETH',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'Kaia Kairos - Testnet',
    short_name: '', 
    chain: '',
    network: '',
    chain_id: 1001,
    network_id: 1001 ,
    rpc_url: 'https://public-en.kairos.node.kaia.io',
    block_scan: 'https://baobab.klaytnscope.com',
    api_url: '',
    native_currency: {
      symbol: 'KLAY',
      name: 'KLAY',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'Unichain Sepolia - Testnet',
    short_name: '', 
    chain: '',
    network: '',
    chain_id: 1301,
    network_id: 1301 ,
    rpc_url: 'https://sepolia.unichain.org',
    block_scan: 'https://sepolia.uniscan.xyz',
    api_url: '',
    native_currency: {
      symbol: 'ETH',
      name: 'ETH',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'Superposition - Testnet',
    short_name: '', 
    chain: '',
    network: '',
    chain_id: 98985,
    network_id: 98985 ,
    rpc_url: 'https://testnet-rpc.superposition.so',
    block_scan: 'https://testnet-explorer.superposition.so',
    api_url: '',
    native_currency: {
      symbol: 'SPN',
      name: 'SPN',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  ,
  {
    name: 'Ink - Testnet',
    short_name: '', 
    chain: '',
    network: '',
    chain_id: 763373,
    network_id: 763373 ,
    rpc_url: 'https://rpc-qnd-sepolia.inkonchain.com',
    block_scan: 'https://explorer-sepolia.inkonchain.com',
    api_url: '',
    native_currency: {
      symbol: 'ETH',
      name: 'ETH',
      decimals: '18',
      contractAddress: '',
      balance: ''
    }
  }
  // {
  //   name: 'Mint - Testnet',
  //   short_name: '', 
  //   chain: '',
  //   network: '',
  //   chain_id: 1686,
  //   network_id: 1686,
  //   rpc_url: 'https://testnet-rpc.mintchain.io',
  //   block_scan: 'https://testnet-explorer.mintchain.io',
  //   api_url: '',
  //   native_currency: {
  //     symbol: 'ETH',
  //     name: 'ETH',
  //     decimals: '18',
  //     contractAddress: '',
  //     balance: ''
  //   }
  // }



  // ,
  // {
  //   name: 'Orenium Testnet Protocol',
  //   short_name: '', 
  //   chain: '',
  //   network: '',
  //   chain_id: 8890,
  //   network_id: 8890,
  //   rpc_url: 'https://rpc-dev-testnet.orenium.org',
  //   block_scan: 'https://testnet.oreniumscan.org',
  //   api_url: '',
  //   native_currency: {
  //     symbol: 'tORE',
  //     name: 'tORE',
  //     decimals: '18',
  //     contractAddress: '',
  //     balance: ''
  //   }
  // }



  // ,
  // {
  //   name: 'Metis - Testnet Goerli',
  //   short_name: '', // 
  //   chain: '',
  //   network: '',
  //   chain_id: 599,
  //   network_id: 599,
  //   rpc_url: 'https://goerli.gateway.metisdevops.link',
  //   block_scan: 'https://goerli.explorer.metisdevops.link/',
  //   api_url: '',
  //   native_currency: {
  //     symbol: 'METIS',
  //     name: 'METIS',
  //     decimals: '18',
  //     contractAddress: '',
  //     balance: ''
  //   }
  // }
  // ,
  // {
  //   name: 'Neon EVM - Testnet Devnet',
  //   short_name: '', // 
  //   chain: '',
  //   network: '',
  //   chain_id: 245022926,
  //   network_id: 245022926,
  //   rpc_url: 'https://devnet.neonevm.org',
  //   block_scan: '',
  //   api_url: '',
  //   native_currency: {
  //     symbol: 'NEON',
  //     name: 'NEON',
  //     decimals: '18',
  //     contractAddress: '',
  //     balance: ''
  //   }
  // }
  


  // ,
  // {
  //   name: 'zkSync ERA - Testnet',
  //   short_name: '', // 
  //   chain: '',
  //   network: '',
  //   chain_id: 280,
  //   network_id: 280,
  //   rpc_url: 'https://testnet.era.zksync.dev',
  //   block_scan: '',
  //   api_url: '',
  //   native_currency: {
  //     symbol: 'ETH',
  //     name: 'ETH',
  //     decimals: '18',
  //     contractAddress: '',
  //     balance: ''
  //   }
  // }
  
]

export function getChainData (chainId) {
  let chainData = supportedChains.filter(
    (chain) => chain.chain_id === chainId
  )[0]

  if (!chainData) {
    chainData = supportedChains[0]
  }

  const API_KEY = process.env.VUE_APP_ALCHEMY_ID

  if (
    chainData.rpc_url.includes('alchemyapi.io') &&
    chainData.rpc_url.includes('%API_KEY%') &&
    chainData.rpc_url.includes('') &&

    API_KEY
  ) {
    const rpcUrl = chainData.rpc_url.replace('%API_KEY%', '', API_KEY)

    return {
      ...chainData,
      rpc_url: rpcUrl
    }
  }

  return chainData
}
